import { deepClone } from '@/helper/lodashHelper';
import localStorageHelper from '@/helper/localStorageHelper';
import { useOverviewStore } from '@/store/overview';
import axios from '@/axios';
import { $settings } from '@/provider/settings';

const formatResult = function (response) {
  const responseData = response.data.DATA || {};
  const { QUERYRESULT = [], HIERRESULT = [], INFO } = responseData;
  const payload = [...QUERYRESULT, ...HIERRESULT];

  return {
    value: payload,
    total: INFO ? INFO.TOTAL : (payload && payload.length > 0) || 0,
  };
};

export default {
  query(store, { type, subType, key, records, options = {} }) {
    const { skip = 0, activeSort = {}, pageAll } = options;

    const skipQuery = `&skip=${skip || 0}`;
    const activeSortQuery =
      (activeSort.sort &&
        `&sort=${activeSort.sort} ${activeSort.asc ? 'asc' : 'desc'}`) ||
      '';
    const pageSizeParameter = pageAll ? `&pageSize=999999` : '';
    const recordsQuery = records ? `&Records=${records}` : '';
    const subTypeQuery = subType ? `&subType=${subType}` : '';

    const cid = localStorageHelper.getCid();

    return axios({
      url: `${$settings.middlewareURI}/exp/${cid}/${type}/query?ref=${key}${recordsQuery}${subTypeQuery}${skipQuery}${activeSortQuery}${pageSizeParameter}`,
    });
  },
  queryObject(
    store,
    { context, type, subType, key, records, autoStore = true, options = {} },
  ) {
    return store
      .dispatch('query', {
        type,
        key,
        records: records || 'QUERYRESULT,INFO',
        subType,
        options,
      })
      .then((response) => {
        if (!response.data.SUCCESS) {
          console.warn(`Cant fetch data from queryObject with key ${key}`);
        }
        const returnResp = formatResult(response);

        if (context) {
          const { pageAll } = options;

          if (autoStore)
            useOverviewStore().setOverview({
              context: pageAll ? 'queryAll' : context,
              type,
              subType,
              payload: returnResp,
            });
        }

        return returnResp;
      });
  },
  updateQueryObject(store, { endpoint, response }) {
    if (response && store.state.results) {
      const clonedResults = deepClone(store.state.results);
      if (!clonedResults[endpoint]) {
        clonedResults[endpoint] = { value: [], total: 0 };
      }

      if (Array.isArray(response)) {
        clonedResults[endpoint].value = response.map((item, key) => {
          const storedItem = clonedResults[endpoint].value[key];
          if (!storedItem) {
            item.MODIFY_FLAG = 'C';
          } else if (storedItem && storedItem.MODIFY_FLAG) {
            item.MODIFY_FLAG = storedItem.MODIFY_FLAG;
          }

          return item;
        });
        clonedResults[endpoint].total = response.length;
      } else {
        clonedResults[endpoint].value.push({
          ...response,
          MODIFY_FLAG: 'C',
        });
        clonedResults[endpoint].total += 1;
      }

      store.commit('SET_RESULTS', {
        endpoint,
        response: clonedResults[endpoint],
      });

      return clonedResults[endpoint];
    }

    return false;
  },
  removeModifyFlags(store, endpoint) {
    const clonedResults = deepClone(store.state.results);
    let modifiedPayload = [];

    if (clonedResults && clonedResults.length > 0) {
      // Remove deleted Items
      modifiedPayload =
        clonedResults.filter(({ MODIFY_FLAG }) => MODIFY_FLAG !== 'D') || [];

      // Remove flags from Items
      modifiedPayload = modifiedPayload.map((item) => ({
        ...item,
        MODIFY_FLAG: '',
      }));

      store.commit('SET_RESULTS', {
        endpoint,
        response: modifiedPayload,
      });

      return modifiedPayload;
    }

    return false;
  },
  async updateQuery(store, { payload, type, key, subType }) {
    const cid = localStorageHelper.getCid();
    const subTypeQuery = subType ? `&subType=${subType}` : '';

    const response = await axios({
      method: 'post',
      data: { QUERYRESULT: payload },
      url: `${$settings.middlewareURI}/exp/${cid}/${type}/query?ref=${key}${subTypeQuery}`,
    });

    const { UPD_AREAS = [], SUCCESS } = response.data;

    if (!SUCCESS) return {};

    const endpoint = type + (subType || '');
    store.dispatch('removeModifyFlags', endpoint);

    // TODO: BE should provide correct format
    const updateAreasMapped = UPD_AREAS.map(({ PARENT, BOTYPE, SUBTYPE }) => ({
      type: BOTYPE,
      subType: SUBTYPE,
      parent: PARENT,
    }));

    return updateAreasMapped;
  },
  updateEditQuery(store, { endpoint, payload }) {
    return store.commit('UPDATE_EDIT_QUERY', { endpoint, payload });
  },
  async fetchBo(store, { type, key }) {
    const cid = localStorageHelper.getCid();

    const response = await axios({
      url: `${$settings.middlewareURI}/exp/${cid}/${type}/query/${key}`,
    });
    if (!response.data.SUCCESS) {
      throw new Error('Error', JSON.stringify(response.data));
    }
    const returnResp = formatResult(response);
    store.commit('SET_RESULTS', { endpoint: type, response: returnResp });
    return returnResp;
  },
};
